import { render, staticRenderFns } from "./call-voicemail-icon.vue?vue&type=template&id=d642dc20"
import script from "./call-voicemail-icon.vue?vue&type=script&lang=js"
export * from "./call-voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d642dc20')) {
      api.createRecord('d642dc20', component.options)
    } else {
      api.reload('d642dc20', component.options)
    }
    module.hot.accept("./call-voicemail-icon.vue?vue&type=template&id=d642dc20", function () {
      api.rerender('d642dc20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/call-voicemail-icon.vue"
export default component.exports